import { render } from "./BuyMethCongrats.vue?vue&type=template&id=79982708"
import script from "./BuyMethCongrats.vue?vue&type=script&lang=js"
export * from "./BuyMethCongrats.vue?vue&type=script&lang=js"

import "./BuyMethCongrats.vue?vue&type=style&index=0&id=79982708&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__